export const ApiQueryKey = {
	userLogs: 'user-logs' as const,
	companies: 'companies',
	addresses: 'addresses',
	me: 'auth/me',
	admins: 'admins',
	clients: 'clients',
	dealers: 'dealers',
	contacts: 'contacts',
	clientGroups: 'client-groups',
	loginHistory: 'logins-histories',

	contents: 'contents',
	products: 'products',

	productTypeCategories: 'product-type-categories',
	productTypes: 'product-types',
	productGroups: 'product-groups',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	productModels: 'product-models',
	orders: 'orders',
	shippingMethods: 'shipping-methods',
	shippingPriorities: 'shipping-priorities',
	roles: 'roles',
	workers: 'workers',
	loginsHistory: 'logins-history',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
